var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "hand-box" }, [
    _c("div", { ref: "signature", staticClass: "signature" }, [
      _c("div", { staticClass: "title" }, [_vm._v("手写签批")]),
      _vm._v(" "),
      _c("div", { staticClass: "cancel", on: { click: _vm.close } }, [
        _vm._v("\n      x\n    "),
      ]),
      _vm._v(" "),
      _c("hr", { staticClass: "divide" }),
      _vm._v(" "),
      _c("canvas", {
        ref: "canvas",
        attrs: { id: "myCanvas" },
        on: {
          touchstart: _vm.touchStart,
          touchmove: _vm.touchMove,
          touchend: _vm.touchEnd,
        },
      }),
      _vm._v(" "),
      _c("div", { staticClass: "operate-btn-wrap" }, [
        _c("button", { on: { click: _vm.commit } }, [_vm._v("提交")]),
        _vm._v(" "),
        _c("button", { on: { click: _vm.overwrite } }, [_vm._v("清除")]),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }